export default __webpack_public_path__ + "static/media/profile_success.c7d6f302.svg";